module.exports = __webpack_public_path__ + "files/173046bb5c818235fdbda9232483f92b.png";